const DEFAULT_MAX_RETRIES = 3;
const DEFAULT_RETRY_DELAY_MS = 2000;

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * Polls fetchUser until the given condition on hasPastDueSubscription is met.
 *
 * @param {Object} options
 * @param {Function} options.fetchUser           - async fn that returns { data: { hasPastDueSubscription } }
 * @param {boolean}  options.expectPastDue       - true to wait for past-due, false to wait for recovery
 * @param {number}  [options.maxRetries=3]       - how many polling attempts
 * @param {number}  [options.retryDelayMs=2000]  - ms to wait between attempts
 * @returns {Promise<boolean>} true if condition was met, false if retries exhausted
 */
export const pollForSubscriptionStatus = async ({
    fetchUser,
    expectPastDue,
    maxRetries = DEFAULT_MAX_RETRIES,
    retryDelayMs = DEFAULT_RETRY_DELAY_MS,
} = {}) => {
    for (let attempt = 1; attempt <= maxRetries; attempt += 1) {
        // eslint-disable-next-line no-await-in-loop
        await delay(retryDelayMs);

        try {
            // eslint-disable-next-line no-await-in-loop
            const res = await fetchUser();
            const user = res?.data;

            if (user?.hasPastDueSubscription === expectPastDue) {
                return true;
            }
        } catch (err) {
            console.warn('pollForSubscriptionStatus: fetch attempt failed', err);
        }
    }

    return false;
};
